import PropTypes from 'prop-types';
import React from 'react';
import en from '../../intl/translations/en';

const MobileForecastCTA = ({ href, onClickPaywall }) => (
  <div className="sl-mobile-forecast-cta">
    <span className="sl-mobile-forecast-cta__text">{en.premiumCTA.MobileForecastCTA.text}</span>
    <a href={href} className="sl-mobile-forecast-cta__link" onClick={onClickPaywall}>
      {en.premiumCTA.MobileForecastCTA.linkText}
    </a>
  </div>
);

MobileForecastCTA.defaultProps = {
  href: null,
  onClickPaywall: null,
};

MobileForecastCTA.propTypes = {
  href: PropTypes.string,
  onClickPaywall: PropTypes.func,
};

export default MobileForecastCTA;
